/**
 * Prevents Angular change detection from
 * running with certain Web Component callbacks
 */
// eslint-disable-next-line no-underscore-dangle
(window as any).__Zone_disable_customElements = true;

// zone.js 0.15 rethrows raw rejection values; keep the 0.11 (2.13.4) "Uncaught (in promise)" Error wrapper for ErrorHandler/Sentry.
// eslint-disable-next-line no-underscore-dangle
(window as any).__zone_symbol__DISABLE_WRAPPING_UNCAUGHT_PROMISE_REJECTION = false;
